import { map } from 'ramda'
import { TransactionsType, Params } from 'app/dataTypes/cafeteria/compensation/transactions'

import SimpleDate from 'app/dataProviders/SimpleDate'
import { v4 as uuid } from 'uuid'
import type { Request } from '../../../index'


type ParamsApi = {
  student_id: number
  food_supplier_id: number
  date_from: string
  date_to: string
}

const apiDateFormat = 'YYYY-MM-DD' as const

export const convertParams = ({
  studentID,
  supplierID,
  dateFrom,
  dateTo,
}: Params): [ParamsApi, null] => {
  return [{
    student_id: parseInt(studentID, 10),
    food_supplier_id: parseInt(supplierID, 10),
    date_from: dateFrom.getString(apiDateFormat),
    date_to: dateTo.getString(apiDateFormat),
  }, null]
}

type ResultApi = Array<{
  datetime: string,
  value: number,
  operation_type: number,
  comment: string
}>

export const convertResult = (data: ResultApi): TransactionsType[] => {
  return map(({ datetime, value, operation_type, comment }) => ({
    ID: uuid(),
    date: new SimpleDate(datetime, apiDateFormat),
    value,
    operationType: operation_type,
    comment,
  }), data)
}

export const GET_COMPENSATION_TRANSACTIONS: Request<Params, TransactionsType[], void> = [
  'cabinet/compensation/transactions',
  'get',
  ['data', 'transactions'],
]
